import * as React from 'react';
import { Button, Intent } from '@blueprintjs/core';

const DEFAULT_VIEW_BUTTON_LABEL = 'Add';

interface Props {
    label?: string;
    onPress?: () => void;
    onClick?: () => void;
};

interface State {}

export class AddButton extends React.Component<Props, State> {

    state: State = {

    }
    
    handlePress = () => {
        const {
            onPress,
            onClick
        } = this.props;

        // Check for either pattern of callback
        // but don't trigger both
        if (onClick) {
            onClick();
        }
        else {
            if (onPress) {
                onPress();
            }
        }
    }

	render() {
        const {
            label
        } = this.props;

        return <Button rightIcon="add" intent={Intent.PRIMARY} text={label ? label : DEFAULT_VIEW_BUTTON_LABEL} onClick={this.handlePress}/>
	}
}
